import { useDispatch, useSelector } from "react-redux";
import LoginComponent from "../../components/auth/LoginComponent";
import { clearRedirect } from "../../redux/actions/redirect";
import React, { useCallback } from "react";

const LoginContainer = () => {
  const authData = useSelector((state) => state.google_auth);
  const redirect = useSelector((state) => state.redirect);

  return (
    <LoginComponent
      authData={authData}
      clearRedirect={clearRedirect}
      redirect={redirect}
    />
  );
};

export default LoginContainer;
